class ProductForm extends HTMLElement {
  constructor () {
    super()

    this.form = this.querySelector('form')
    if (!this.form) return

    this.productOptions = this.form.querySelectorAll('.product-options [name*="option"]')
    this.atcButton = this.form.querySelector('.btn-atc')
    this.section = this.closest('[data-product-main-section]')

    this.form.addEventListener('submit', event => this.onSubmit(event))
    this.productOptions.forEach(element => {
      element.addEventListener('change', event => this.onChangeProductOption(event))
    })
    this.form.querySelectorAll('[data-blend-scent]').forEach(element => {
      element.addEventListener('change', () => this.updateBlendState())
    })
    this.updateBlendState()
  }

  getSelectedOptionValueIds () {
    return Array.from(this.productOptions).flatMap(element => {
      if (element.type === 'radio' && !element.checked) return []
      const selected = element.type === 'select-one'
        ? element.options[element.selectedIndex]
        : element
      return selected?.dataset.optionValueId ? [selected.dataset.optionValueId] : []
    })
  }

  async onChangeProductOption (event) {
    event.preventDefault()
    if (!this.section) return

    const selectedOptionValueIds = this.getSelectedOptionValueIds()
    const selectedElement = event.target.type === 'select-one'
      ? event.target.options[event.target.selectedIndex]
      : event.target
    const productUrl = selectedElement.dataset.productUrl || this.section.dataset.productUrl
    const params = new URLSearchParams({
      section_id: this.section.dataset.sectionId,
      option_values: selectedOptionValueIds.join(',')
    })

    this.section.classList.add('loading')

    try {
      const response = await fetch(`${productUrl}?${params.toString()}`)
      if (!response.ok) throw new Error('Unable to load this option.')
      const responseText = await response.text()
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const nextSection = html.querySelector('[data-product-main-section]')
      if (!nextSection) throw new Error('Unable to update this product.')

      const nextVariantId = nextSection.querySelector('[name="id"]')?.value
      const optionValueId = selectedElement.dataset.optionValueId
      this.section.replaceWith(nextSection)

      const pageUrl = new URL(productUrl, window.location.origin)
      if (nextVariantId) pageUrl.searchParams.set('variant', nextVariantId)
      window.history.replaceState({}, '', pageUrl)

      if (optionValueId) {
        nextSection.querySelector(`[data-option-value-id="${CSS.escape(optionValueId)}"]`)?.focus()
      }
    } catch (error) {
      this.section.classList.remove('loading')
      this.showCustomizationError(error.message)
    }
  }

  updateBlendState () {
  const blends = this.form.querySelectorAll('[data-custom-blend]')
  if (!blends.length) return

  blends.forEach(blend => {
    const second = blend.querySelector('[data-blend-scent="2"]')
    const third = blend.querySelector('[data-blend-scent="3"]')
    if (!second || !third) return

    third.disabled = !second.value
    if (!second.value) third.value = ''

    const selectedScents = this.getSelectedBlendScents(blend)
    const hasDuplicate = selectedScents.some(
      (value, index) => selectedScents.indexOf(value) !== index
    )
    const message = blend.querySelector('[data-custom-option-message]')

    if (!message) return

    if (hasDuplicate) {
      message.textContent = 'Choose a different fragrance for each scent selection.'
      message.classList.add('text-danger')
    } else {
      message.textContent = third.value
        ? 'Three-scent blend: +$6'
        : second.value
          ? 'Two-scent blend: +$3'
          : 'One scent is included.'

      message.classList.remove('text-danger')
    }
  })
}

  normalizeScent (value) {
    return value
      .toLowerCase()
      .replaceAll('-', ' ')
      .replace('breathe easee', 'breathe easy')
      .trim()
  }

  getSelectedBlendScents (blend) {
    const ownFirstScent = blend.querySelector('[data-blend-scent="1"]')

const nativeScentRadio = ownFirstScent
  ? null
  : this.form.querySelector('.product-options input[name*="scent" i]:checked')

const nativeScentSelect = ownFirstScent
  ? null
  : this.form.querySelector('.product-options select[name*="scent" i]')

const nativeScent = nativeScentRadio?.value || nativeScentSelect?.value || ''

const customScents = Array.from(
  blend.querySelectorAll('[data-blend-scent]')
).map(element => element.value)

return [nativeScent, ...customScents]
  .filter(Boolean)
  .map(value => this.normalizeScent(value))
  }

  validateCustomOptions () {
    if (!this.form.reportValidity()) return false

    const blends = Array.from(this.form.querySelectorAll('[data-custom-blend]'))

for (const blend of blends) {
  const selectedScents = this.getSelectedBlendScents(blend)

  if (selectedScents.some(
    (value, index) => selectedScents.indexOf(value) !== index
  )) {
    this.showCustomizationError(
      'Choose a different fragrance for each scent selection.'
    )
    return false
  }

  const second = blend.querySelector('[data-blend-scent="2"]')
  const third = blend.querySelector('[data-blend-scent="3"]')

  const requiredUpgrade = third?.value
    ? blend.dataset.upgradeThree
    : second?.value
      ? blend.dataset.upgradeTwo
      : ''

  if ((second?.value || third?.value) && !requiredUpgrade) {
    this.showCustomizationError(
      'The custom-blend pricing item must be imported before this option can be purchased.'
    )
    return false
  }
}
    const missingPricedUpgrade = Array.from(this.form.querySelectorAll('[data-upgrade-select]')).some(select => {
      const option = select.options[select.selectedIndex]
      return select.selectedIndex > 0 && !option.dataset.upgradeId
    })
    if (missingPricedUpgrade) {
      this.showCustomizationError('The selected upgrade must be imported before it can be purchased.')
      return false
    }

    return true
  }

  showCustomizationError (message) {
    const liveRegion = this.form.querySelector('[data-custom-option-message]')
    if (liveRegion) {
      liveRegion.textContent = message
      liveRegion.classList.add('text-danger')
    } else {
      window.alert(message)
    }
  }

  buildCartItems () {
    const formData = new FormData(this.form)
    const quantity = Number(formData.get('quantity') || 1)
    const groupKey = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
    const properties = { '_Customization group': groupKey }

    for (const [key, value] of formData.entries()) {
      const propertyMatch = key.match(/^properties\[(.+)\]$/)
      if (propertyMatch && value) properties[propertyMatch[1]] = value
    }

    const items = [{
      id: Number(formData.get('id')),
      quantity,
      properties
    }]

    const blends = this.form.querySelectorAll('[data-custom-blend]')

blends.forEach(blend => {
  const second = blend.querySelector('[data-blend-scent="2"]')
  const third = blend.querySelector('[data-blend-scent="3"]')

  const upgradeId = third?.value
    ? blend.dataset.upgradeThree
    : second?.value
      ? blend.dataset.upgradeTwo
      : ''

  if (upgradeId) {
    items.push({
      id: Number(upgradeId),
      quantity,
      properties: { '_Customization parent': groupKey }
    })
  }
})
    this.form.querySelectorAll('[data-upgrade-select]').forEach(select => {
      const selectedOption = select.options[select.selectedIndex]
      if (selectedOption.dataset.upgradeId) {
        items.push({
          id: Number(selectedOption.dataset.upgradeId),
          quantity,
          properties: { '_Customization parent': groupKey }
        })
      }
    })
const sampleTinBlends = this.form.querySelector('[data-sample-tin-blends]')

if (sampleTinBlends) {
  const upgradeId = sampleTinBlends.dataset.upgradeId
  const extraScents = sampleTinBlends.querySelectorAll('[data-sample-extra-scent]')

  let extraCount = 0

  extraScents.forEach(select => {
    if (select.value) extraCount += 1
  })

  if (upgradeId && extraCount > 0) {
    items.push({
      id: Number(upgradeId),
      quantity: extraCount * quantity,
      properties: { '_Customization parent': groupKey }
    })
  }
}

    return items
  }

  async onSubmit (event) {
    event.preventDefault()
    if (!this.validateCustomOptions()) return

    this.atcButton?.classList.add('loading')
    if (this.atcButton) {
      this.atcButton.disabled = true
      this.atcButton.setAttribute('aria-busy', 'true')
    }

    const cart = document.querySelector('cart-container')
    const hasCustomizations = this.form.querySelector('[data-custom-blend], [data-upgrade-select], [data-required-custom-options]')

    if (hasCustomizations) {
      await cart.addItems(this.buildCartItems())
    } else {
      await cart.add(new FormData(this.form))
    }

    this.atcButton?.classList.remove('loading')
    if (this.atcButton) {
      this.atcButton.disabled = false
      this.atcButton.setAttribute('aria-busy', 'false')
    }
  }
}
customElements.define('product-form', ProductForm)

class ProductMediaGallery extends HTMLElement {
  constructor () {
    super()
    const initialSlide = Number(this.dataset.initialSlide)
    this.thumbs = new window.Swiper(this.querySelector('.swiper-thumbs'), this.thumbsOptions())
    this.main = new window.Swiper(this.querySelector('.swiper-main'), this.mainOptions())
    this.main.slideTo(initialSlide)
    this.setStickyPosition()
  }

  thumbsOptions () {
    return {
      slidesPerView: Number(this.dataset.thumbsPerView),
      spaceBetween: 10
    }
  }

  mainOptions () {
    return {
      speed: Number(this.dataset.speed),
      rewind: true,
      pagination: {
        type: 'bullets',
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2
      },
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      thumbs: {
        swiper: this.thumbs,
        autoScrollOffset: 1
      }
    }
  }

  setStickyPosition () {
    if (!this.closest('.product-main') || !window.matchMedia('(min-width: 1200px)').matches) return
    const headerGroup = document.querySelector('#header-group.sticky-top')
    if (!headerGroup) return
    let oldScroll = window.scrollY

    window.addEventListener('scroll', () => {
      const newScroll = window.scrollY
      this.style.top = newScroll > oldScroll ? '20px' : `${headerGroup.clientHeight + 20}px`
      oldScroll = Math.max(window.scrollY, 0)
    })
  }
}
customElements.define('product-media-gallery', ProductMediaGallery)

const adjustShopifySubscriptionsStyling = () => {
  document.querySelectorAll('.shopify_subscriptions_app_block [type="radio"]').forEach(radio => {
    radio.classList.add('form-check-input')
  })
}
adjustShopifySubscriptionsStyling()
window.addEventListener('kt.product.quick_view.modal_shown', adjustShopifySubscriptionsStyling)
